import { ReactNode, CSSProperties } from 'react';

export const TableWrapper = ({
  children,
  style,
}: {
  children: ReactNode;
  style?: CSSProperties;
}) => {
  return (
    <table
      className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 overflow-hidden"
      style={style}
    >
      {children}
    </table>
  );
};
